import { LoaderIcn } from 'utils/icons';

const classNames = ['mb-2 w-[68px] h-[68px]', 'mb-4 w-[100px] h-[100px]'];

const Loader = ({ isMain }) => (
  <div className="absolute-center text-center font-400 text-16 text-gray-80">
    <LoaderIcn className={`animate-spin ${classNames[+isMain]}`} />
    Loading...
  </div>
);

const Spinner = ({ isMain }) => {
  if (isMain) {
    return <div className="page"><Loader isMain={isMain} /></div>;
  }

  return <Loader isMain={isMain} />;
};

export default Spinner;
